import cn from "classnames";
import React, { FC, ReactNode, useRef } from "react";
import { ModalState } from "src/hooks/useModal";
import { useClickOutside } from "src/hooks/useClickOutside";
import { Portal } from "./Portal";
import { Overlay } from "./Overlay";
import { Modal } from "./Modal";
import { MODAL_CLASSNAME, MODAL_OVERLAY_CLASSNAME } from "./constants";
import { ModalMode } from "./types";
import { CloseButton } from "./CloseButton";

interface Props extends ModalState {
  children: ReactNode;
  mode?: ModalMode;
  isActivePortal?: boolean;
  isShownOverlay?: boolean;
  isShownCloseButton?: boolean;
  isActiveCloseClickOutside?: boolean;
  overlayClassName?: string;
  className?: string;
}

export const ModalWindowV2: FC<Props> = ({
  mode = ModalMode.default,
  isActiveCloseClickOutside = true,
  isActivePortal = true,
  isShownOverlay = true,
  children,
  isOpenModal,
  isVisible,
  className,
  isShownCloseButton,
  overlayClassName,
  closeModal,
}) => {
  const modalRef = useRef(null);
  useClickOutside(modalRef, closeModal, isActiveCloseClickOutside);

  const combinedOverlayClassNames = cn(
    {
      [MODAL_OVERLAY_CLASSNAME[mode].visible]: isVisible,
      [MODAL_OVERLAY_CLASSNAME[mode].invisible]: !isVisible,
    },
    overlayClassName
  );

  const combinedModalClassNames = cn(
    {
      [MODAL_CLASSNAME[mode].visible]: isVisible,
      [MODAL_CLASSNAME[mode].invisible]: !isVisible,
    },
    className
  );

  if (!isOpenModal) return null;

  return (
    <Portal isActivePortal={isActivePortal}>
      <Overlay
        isShownOverlay={isShownOverlay}
        className={combinedOverlayClassNames}
      >
        <Modal ref={modalRef} className={combinedModalClassNames}>
          {isShownCloseButton && <CloseButton closeModal={closeModal} />}
          {children}
        </Modal>
      </Overlay>
    </Portal>
  );
};
